import React from 'react';
import { useTheme } from '../../shared/theme/ThemeContext';
import './Logo.css';
import logoBlue from '../../assets/logo/crew_core_logo_blue.png';
import logoWhite from '../../assets/logo/crew_core_logo_white.png';
import namedLogoBlue from '../../assets/logo/crew_core_named_logo_blue.png';
import namedLogoWhite from '../../assets/logo/crew_core_named_logo_white.png';

const logos = {
  default: { light: logoBlue, dark: logoWhite },
  named: { light: namedLogoBlue, dark: namedLogoWhite },
};

const Logo = ({ alt, className, size = 40, variant = 'default' }) => {
  const { isDarkMode } = useTheme();
  const src = (logos[variant] || logos.default)[isDarkMode ? 'dark' : 'light'];

  return (
    <img
      src={src}
      alt={alt || 'App Logo'}
      className={className}
      style={{ width: size, height: size, objectFit: 'contain' }}
    />
  );
};

export default Logo;
